<template>
  <div id="cooperation">
    <!-- <el-menu :default-active="onRoutes('name')" class="menu-content" mode="horizontal" active-text-color="#ffffff" text-color="#ffffff" background-color="transparent">
      <el-menu-item v-for="item in menuList" :index="item.name" :key="item.text"><router-link :to="{ name: item.name}">{{item.text}}</router-link></el-menu-item>
    </el-menu> -->
    <van-tabs :active="onRoutes('name')"
              color="#34D1BC"
              background="rgba(0,0,0,.3)"
              @change="onClickTab">
      <van-tab v-for="item in menuList"
               :index="item.name"
               :key="item.text"
               :name="item.name"
               :title="item.text">
      </van-tab>
    </van-tabs>
    <div class="details">
      <transition name="fade-transform"  mode="out-in">
        <router-view :menuList="menuList" />
      </transition>
    </div>
  </div>
</template>

<script>
import Partner from './partner'

export default {
  components: {
    Partner
  },
  data () {
    return {
      menuList: [
        {
          text: '关于我们',
          name: 'aboutUs'
        }, {
          text: '公司资讯',
          name: 'companyNews'
        }, {
          text: '合作伙伴',
          name: 'partner'
        }, {
          text: '商务合作',
          name: 'business'
        }, {
          text: '联系客服',
          name: 'service'
        }
      ]
    }
  },
  methods: {
    onClickTab (name, title) {
      this.$router.push({ name })
    },
    onRoutes (type) {
      let defActive = this.$route.matched;
      for (let i = 0; i < defActive.length; i++) {
        for (let n = 0; n < this.menuList.length; n++) {
          if (defActive[i].name == this.menuList[n].name) {
            return defActive[i].name;
          }
        }
      }
    }
  }
}

</script>
<style lang="stylus" scoped>
#cooperation
  height 100%

  >>> .van-tabs--line .van-tabs__wrap
    height 40px

    .van-tab__text
      color #fff

/* @media only screen and (max-width: 1280px){ */
/* .menu-content .el-menu-item a { */
/* !*font-size: 12px;*! */
/* text-align: center; */
/* width: 100%; */
/* } */
/* .menu-content.el-menu--horizontal.el-menu .el-menu-item { */
/* margin: 0; */
/* } */
/* .el-menu--horizontal>.el-menu-item { */
/* width: 23%; */
/* max-width: 120px; */
/* } */
/* } */
</style>
